import React, { useContext } from 'react';
import moment from 'moment';
import LocalizationContext from '../../contexts/Localizations';
import NewsCardProps from './type';
import { DateAndCategory, Image, SvgImage } from '../common';
import './styles.scss';

const NewsCard = ({
  category,
  title,
  date,
  thumbnail,
  type,
  url,
  viewMoreLink,
}: NewsCardProps) => {
  const { locale } = useContext(LocalizationContext);
  return (
    <div
      className={`
        news-card ${type && `news-card--${type.toLowerCase()}`}
        ${category && `news-card--discipline-${category.discipline}`}
        ${!thumbnail && 'news-card--no-thumbnail'}
        ${viewMoreLink && 'news-card--with-view-more'}
      `}
    >
      <div className="news-card__details">
        <div className="news-card__category">
          <DateAndCategory category={category} />
        </div>
        <div className="news-card__title">
          {url && (
            <a href={url}>
              {title}
            </a>
          )}
          {!url && (
            <>{title}</>
          )}
        </div>
        {viewMoreLink && (
          <div className="news-card__view-more">
            <a className="link link--has-icon false false" href={viewMoreLink.url}>
              <span>{viewMoreLink.title}</span>
              <div className="link__icon">
                <SvgImage title="arrow" reference="#icon-think-arrow" />
              </div>
            </a>
          </div>
        )}
      </div>
      {thumbnail && (
        <div className="news-card__image">
          {Boolean(type && type.toLowerCase() === 'video') && (
            <div className="news-card__icon">
              <SvgImage title="Video" reference="#icon-video-empty" />
            </div>
          )}
          <Image
            url={thumbnail.file?.url}
            alt={thumbnail.title}
            widthSizes={['300', '600']}
            aspectRatio="4x3"
          />
        </div>
      )}
      {date && (
        <div className="news-card__date">
          {date && moment(date).locale(locale).format('DD MMM YY')}
        </div>
      )}
    </div>
  );
};

export default NewsCard;
